module.exports = __webpack_public_path__ + "static/img/pass.6119882a.png";